export default {
  id: 154,
  title: 'Target #154 - Poker Chip',
  url: 'https://cssbattle.dev/play/154',
  colors: ['#998235', '#FCBE5C', '#0B2429'],
  solution:
    '<a a><a b><a c><a d><a e><style>[a],[b],[c],[d]{left:185;width:30;background:#0b2429}[a],[b],[c],[d],[e]{top:0;height:300}body{background:#fcbe5c}a{position:fixed}[b]{transform:rotate(45deg)}[c]{transform:rotate(90deg)}[d]{transform:rotate(135deg)}[e]{left:0;width:400;background:radial-gradient(circle,#0b2429 60px,#fcbe5c 60px 70px,#0b2429 70px 80px,transparent 80px 95px,#0b2429 95px 105px,#998235 105px)}</style>',
}
